//import React from "react";
import React, { useEffect, useState, useContext } from "react";
import AsyncSearchSelect from "./AsyncSearchSelect";
import lookupService from "../services/lookupService";
import Select from "react-select";

import {
  getCountries,
  getStates,
  getCities
} from "../../../../../../constants/geographyMaster";

import { AuthContext } from "../../../../../../context/AuthContext";
import { getDepartmentsByLocation } from "../../../../../../services/departmentService";

const POHeaderSection = ({
  form,
  setForm,
  selectedVendor,
  setSelectedVendor,
}) => {

  
  const { activeScope } = useContext(AuthContext);

const [departments, setDepartments] = useState([]);
  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };
useEffect(() => {

  if (
    activeScope?.tenant_id &&
    activeScope?.location_id
  ) {
    loadDepartments();
  }

}, [
  activeScope?.tenant_id,
  activeScope?.location_id
]);

const loadDepartments = async () => {

  try {

    const depData =
      await getDepartmentsByLocation(
        activeScope?.tenant_id,
        activeScope?.location_id
      );

    const options = (depData?.data || []).map((d) => ({
      value: d.id,
      label: d.name
    }));

    setDepartments(options);

  } catch (err) {

    console.error(
      "Failed to load departments",
      err
    );

  }

};
  return (
    <>
      {/* BASIC INFO */}
      <div className="row mb-3">
        <div className="col-md-6">
          <label>Vendor</label>

          <AsyncSearchSelect
            placeholder="Search Vendor..."
            loadOptions={lookupService.searchVendors}
            value={selectedVendor}
            onChange={(v) => {
              setSelectedVendor(v);
              setForm({
                ...form,
                vendor_id: v?.id || "",
              });
            }}

            labelKey="name"
            valueKey="id"
          />

        </div>

        <div className="col-md-4">
    <label>Requested Department</label>

    <Select
      options={departments}
      placeholder="Select Department"
      menuPortalTarget={document.body}
      menuPosition="fixed"
      styles={{
        menuPortal: (base) => ({
          ...base,
          zIndex: 9999,
        }),
      }}
      value={
        departments.find(
          (d) =>
            String(d.value) ===
            String(form.requested_department_id)
        ) || null
      }
      onChange={(selected) =>
        setForm({
          ...form,
          requested_department_id:
            selected?.value || ""
        })
      }
    />
  </div>

        <div className="col-md-6">
          <label>Purpose</label>
          <select
            className="form-control"
            name="procurement_purpose"
            value={form.procurement_purpose}
            onChange={handleChange}
          >
            <option value="STOCK">STOCK</option>
            <option value="PROJECT">PROJECT</option>
            <option value="ORDER">ORDER</option>
          </select>
        </div>
      </div>

      {/* CONDITIONAL FIELDS */}
      <div className="row mb-3">
        {form.procurement_purpose === "PROJECT" && (
          <div className="col-md-6">
            <label>Project ID</label>
            <input
              className="form-control"
              name="project_id"
              value={form.project_id}
              onChange={handleChange}
            />
          </div>
        )}

        {form.procurement_purpose === "ORDER" && (
          <div className="col-md-6">
            <label>Order ID</label>
            <input
              className="form-control"
              name="order_id"
              value={form.order_id}
              onChange={handleChange}
            />
          </div>
        )}
      </div>

      {/* REFERENCES */}
      <div className="row mb-3">
        <div className="col-md-4">
          <label>PR Reference</label>
          <input
            className="form-control"
            name="pr_id"
            value={form.pr_id || ""}
            onChange={handleChange}
             disabled
          />
        </div>

        <div className="col-md-4">
          <label>Indent Reference</label>
          <input
            className="form-control"
            name="indent_id"
            value={form.indent_id}
            onChange={handleChange}
            disabled
          />
        </div>

        <div className="col-md-4">
          <label>RFQ Reference</label>
          <input
            className="form-control"
            name="rfq_id"
            value={form.rfq_id}
            onChange={handleChange}
            disabled
          />
        </div>
      </div>

      {/* DELIVERY ADDRESS */}
      <div className="card mb-3">
        <div className="card-header fw-bold">
          Delivery Address
        </div>

        <div className="card-body">

          <div className="row mb-3">
            <div className="col-md-6">
              <label>Address Line 1</label>
              <input
                className="form-control"
                name="delivery_address_line1"
                value={form.delivery_address_line1}
                onChange={handleChange}
              />
            </div>

            <div className="col-md-6">
              <label>Address Line 2</label>
              <input
                className="form-control"
                name="delivery_address_line2"
                value={form.delivery_address_line2}
                onChange={handleChange}
              />
            </div>
          </div>

          <div className="row mb-3">

            <div className="col-md-4">
              <label>Country</label>

              <Select
                options={getCountries()}
                value={
                  getCountries().find(
                    c => c.value === form.delivery_country
                  ) || null
                }
                onChange={(selected) =>
                  setForm({
                    ...form,
                    delivery_country:
                      selected?.value || "",
                    delivery_state: "",
                    delivery_city: ""
                  })
                }
                isSearchable
              />
            </div>

            <div className="col-md-4">
              <label>
                State <span className="text-danger">*</span>
              </label>

              <Select
                options={getStates(
                  form.delivery_country
                )}
                value={
                  getStates(
                    form.delivery_country
                  ).find(
                    s =>
                      s.value ===
                      form.delivery_state
                  ) || null
                }
                
                onChange={(selected) =>
                  setForm({
                    ...form,
                    delivery_state:
                      selected?.value || "",
                    delivery_city: ""
                  })
                }
                isSearchable
              />
            </div>

            <div className="col-md-4">
              <label>City</label>

              <Select
                options={getCities(
                  form.delivery_country,
                  form.delivery_state
                )}
                value={
                  getCities(
                    form.delivery_country,
                    form.delivery_state
                  ).find(
                    c =>
                      c.value ===
                      form.delivery_city
                  ) || null
                }
                onChange={(selected) =>
                  setForm({
                    ...form,
                    delivery_city:
                      selected?.value || ""
                  })
                }
                isSearchable
              />
            </div>

          </div>

          <div className="row">

            <div className="col-md-4">
              <label>Pincode</label>
              <input
                className="form-control"
                name="delivery_pincode"
                value={form.delivery_pincode}
                onChange={handleChange}
              />
            </div>

          </div>

        </div>
      </div>
      
      {/* COMMERCIAL TERMS */}
      <div className="row mb-3">
        

        <div className="col-md-4">
          <label>Payment Terms</label>
          <textarea
            className="form-control"
            rows={3}
            name="payment_terms"
            value={form.payment_terms}
            onChange={handleChange}
          />
        </div>

        <div className="col-md-4">
          <label>Delivery Terms</label>
          <textarea
            className="form-control"
            rows={3}
            name="delivery_terms"
            value={form.delivery_terms}
            onChange={handleChange}
          />
        </div>

        <div className="col-md-4">
          <label>Delivery Date</label>
          <input
            type="date"
            className="form-control"
            name="delivery_date"
            value={form.delivery_date}
            onChange={handleChange}
            required
          />
        </div>
      </div>

      <div className="row mb-3">
        <div className="col-md-6">
          <label>Currency</label>
          <select
            className="form-control"
            name="currency"
            value={form.currency}
            onChange={handleChange}
          >
            <option value="INR">INR</option>
            <option value="USD">USD</option>
          </select>
        </div>

        <div className="col-md-6">
          <label>Remarks</label>
          <textarea
            className="form-control"
            name="remarks"
            value={form.remarks}
            onChange={handleChange}
          />
        </div>
      </div>
    </>
  );
};

export default POHeaderSection;
